import api from "./apiLogisticsTool.js";

export default {
  GetProceduresByUserName(username) {
    return api.get("Procedures/GetProceduresByUserName/" + username);
  },

  GetProceduresStockAddOn(name) {
    return api.get("Procedures/GetProceduresStockAddOn/" + name);
  },

  GetDatabaseFromStockSystem() {
    return api.get("Procedures/GetDatabaseFromStockSystem");
  },

  GetInfromationParameters(spStoreProcedureName) {
    return api.get(
      "Procedures/GetInfromationParameters/" + spStoreProcedureName
    );
  },

  GetProcedure(id) {
    return api.get("Procedures/GetProcedure/" + id);
  },

  InsertProcedureWithParameters(pwp) {
    return api.post("Procedures/InsertProcedureWithParameters", pwp);
  },

  InsertProcedure(procedure) {
    return api.post("Procedures/InsertProcedure,", procedure);
  },

  EditProcedure(procedure) {
    return api.put("Procedures/EditProcedure", procedure);
  },  

  ExecuteProcedure(obj) {
    return api.post("Procedures/ExecuteProcedure", obj);
  },

  GetProcedures() {
    return api.get("Procedures/GetProcedures");
  },

  DeleteProcedure(id) {
    return api.delete("Procedures/DeleteProcedure/" + id);
  },
};
